module.exports = __webpack_public_path__ + "static/media/bg-darkgrey-top-left.aab9023f.png";